import { TThunkAction } from '../../types/redux/thunk';
import { fetchDeleteFromComparison } from '../../repositories/property-comparison/v1/delete-from-comparison';
import { deleteNewbuildingFromComparisonSuccess } from './deleteNewbuildingFromComparisonActions';

interface IDeleteNewbuildingFromComparison {
  newbuildingId: number;
}

export const deleteNewbuildingFromComparison =
  ({ newbuildingId }: IDeleteNewbuildingFromComparison): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, { logger, httpApi }) => {
    // Оптимистично убираем колонку ЖК из таблицы. Результат запроса на UI не влияет:
    // при ошибке колонку тоже удаляем (без роллбэка).
    dispatch(deleteNewbuildingFromComparisonSuccess({ newbuildingId }));

    try {
      await fetchDeleteFromComparison({
        httpApi,
        parameters: {
          propertyType: 'newbuilding',
          propertyId: newbuildingId,
        },
      });
    } catch (error) {
      logger.error(error, {
        newbuildingId,
        domain: 'src/shared/actions/newbuildingsCompare#deleteNewbuildingFromComparison()',
        message: error.message,
      });
    }
  };
